import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchCallHistory } from '../../../../redux/myCourse/myCourse.actions';
import CallHistoryRows from './callHistoryRows';

const CallHistory = ({ fetchCallHistory, callHistoryList }) => {
	useEffect(() => {
		fetchCallHistory();
	}, [fetchCallHistory]);

	return (
		<div>
			<table className="table callHistory">
				<thead>
					<tr>
						<th>#</th>
						<th>Call time</th>
						<th>Call status</th>
						<th>Call recording</th>
					</tr>
				</thead>
				<tbody>
					{!!callHistoryList && callHistoryList.length > 0 ? (
						callHistoryList.map((callDetails, index) => (
							<CallHistoryRows row={index} {...callDetails} />
						))
					) : (
						<tr>
							<td valign="top" colSpan="15" className="CoachTablesEmpty">
								Calls has not been scheduled yet
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		callHistoryList: state.rootReducer.myCourse.callHistory,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchCallHistory: () => dispatch(fetchCallHistory()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CallHistory);
